<template>
  <!-- 新建生产单-生产单头部部分 -->
  <div>
    <el-form :model="productOrderHeader" :rules="productOrderHeaderRelues" ref="productOrderHeaderFormRef" inline>
      <el-form-item label=" " prop="consignTime">
        <el-date-picker
          v-model="productOrderHeader.consignTime"
          type="date"
          size="large"
          placeholder="选择交期"
          value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-for="(obj,key) in productOrderKeys" :key="key" :prop="key" label=" ">
        <el-input v-model="productOrderHeader[key]" placeholder="请输入内容"
          :style="{width:obj.width}">
          <template slot="prepend">{{obj.value}}</template>
        </el-input>
      </el-form-item>
    </el-form>
    <el-input v-model="productOrderHeader.remarks" placeholder="请输入内容" width="100%">
      <template slot="prepend">订单说明</template>
    </el-input>
  </div>
</template>

<script>
export default {
  data() {
    var amountruler = (rules, value, cb) => {
      const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/
      if (ruler.test(value)) {
        return cb()
      }
      cb(new Error('请输入大于0的正整数'))
    }
    var amountMax = (rules, value, cb) => {
      if (Number(value) <= 20000000) {
        return cb()
      }
      cb(new Error('最大值不能超过20000000'))
    }
    return {
      productOrderKeys: {
        customer: { value: '客户', width: '200px' },
        amount: { value: '订单数量(米)', width: '250px' },
        craftOrganization: { value: '工艺组织', width: '220px' },
        density: { value: '针织密度(R/CM)', width: '250px' },
        squareGrams: { value: '平方克', width: '200px' }
      },
      productOrderHeader: {
        consignTime: '',
        customer: '',
        amount: '',
        craftOrganization: '',
        density: '',
        remarks: '',
        squareGrams: ''
      },
      productOrderHeaderRelues: {
        consignTime: [{ required: true, message: '请选择交付日期', trigger: 'blur' }],
        customer: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入订单数量', trigger: 'blur' },
        { validator: amountruler, trigger: 'blur' }, { validator: amountMax, trigger: 'blur' }],
        craftOrganization: [{ required: true, message: '请输入工艺组织', trigger: 'blur' }],
        density: [{ required: true, message: '请输入针织密度', trigger: 'blur' }],
        remarks: [{ required: true, message: '请输入订单说明', trigger: 'blur' }],
        squareGrams: [{ required: true, message: '请输入平方克', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 外部调用，获取生产单头部
    getProductOrderHeader() {
      const cloneHeader = this._.cloneDeep(this.productOrderHeader)
      cloneHeader.amount = cloneHeader.amount * 100
      return cloneHeader
    },
    // 验证必填的输入框是否都有填写
    getValid() {
      this.$refs.productOrderHeaderFormRef.validate(valid => {
          this.valid = valid
      })
      return this.valid
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 50px;
    padding: 0 12px 0 0;
    width:80px !important;
    box-sizing: border-box;
}
.el-form--inline .el-form-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    height: 40px;
}
</style>
